import { useQuery } from '@tanstack/react-query';
import {
  GetAllListWithdrawRequestEntity,
  WithdrawRequestService,
} from 'services/openapi';

import { RequestWithdrawQueryKeys } from '../constants';
import { isEmpty } from 'lodash';

type GetListRequestWithdrawDTO = {
  transactionStatus:
    | 'Tất cả'
    | 'Thành công'
    | 'Từ chối'
    | 'Đang xử lý'
    | 'Đang chuyển tiền tự động'
    | 'Chuyển tiền tự động thất bại';
  // transactionStatus: 'Thành công' | 'Từ chối' | 'Đang xử lý';
  transactionCode?: string;
  phoneNumber?: string;
  fromTime: string;
  toTime: string;
  page: string;
  pageSize: string;
  companyId?: string;
};

export const useGetRequestWihtdraw = (variables: GetListRequestWithdrawDTO) => {
  const queryKey = [
    RequestWithdrawQueryKeys.GET_LIST_REQUEST_WITHDRAW,
    variables,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<GetAllListWithdrawRequestEntity, Error>({
    queryKey,
    queryFn: () =>
      WithdrawRequestService.withdrawRequestControllerGetAllList(
        variables.fromTime?.trim(),
        variables.toTime?.trim(),
        variables.phoneNumber?.trim(),
        variables.transactionStatus,
        variables.page,
        variables.pageSize,
        variables.companyId,
      ),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: !isEmpty(variables),
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data: data,
    isError,
    queryKey,
    refetch,
  };
};
